import React, { Component } from "react"
import ReactDOM from "react-dom"
import "./Card.css"
import { connect } from "react-redux"
import { push, goBack } from "react-router-redux"
import {
  MoreIcon,
  ShareIcon,
  FromToIcon,
  PlusIcon,
  CrownIcon,
  BriefcaseIcon,
  MarkerIcon,
  ForwardIcon,
  HomeIcon,
  DotIcon,
  BackIcon
} from "./icons"
import styled, { keyframes } from "styled-components"
import { Row, Col, Icon as AIcon, Button } from "antd"
import { StickyContainer, Sticky } from "react-sticky"
const EmptyDiv = styled.div`
  background: white;
  opacity: 0.9;
  z-index: 2;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 4px;
`
const FetchingIcon = styled(AIcon).attrs({
  type: "loading"
  // size: props => props.small ? 3 : 8
})`
  font-size: 50px;
  font-weight: 600;
  color: #31b59f;
  height: 0;
  position: absolute;
  top: 40%;
  right: 50%;
`

// https://github.com/captivationsoftware/react-sticky/issues/188
const sticky = ComposedComponent =>
  class extends Component {
    render() {
      return <ComposedComponent {...this.props} />
    }
  }

export const Card = ({
  children,
  className = "",
  gridArea = "",
  style,
  showLoadingIcon,
  ...rest
}) => (
  <div
    className={`Card ${className}`}
    {...rest}
    style={{
      marginBottom: 20, // bottom gutter between cards
      ...style,
      ...(showLoadingIcon ? { position: "relative" } : {})
    }}
  >
    {showLoadingIcon && (
      <EmptyDiv>
        <FetchingIcon />
      </EmptyDiv>
    )}
    {/* {showLoadingIcon&& <FetchingIcon/>} */}
    {children}
  </div>
)

export const StickyCard = sticky(Card)

export const TitleCard = connect(state => state)(
  ({
    sticky,
    children,
    dispatch,
    router,
    backTo,
    showBackButton,
    shareable = false,
    moreActions = false
  }) => {
    if (sticky)
      return (
        // wrapping div prevents sticky jump
        <div style={{ marginBottom: 20 }}>
          <Sticky>
            {({ style, isSticky }) => {
              return (
                <StickyCard
                  style={{ ...style, zIndex: 1000 }}
                  className={
                    showBackButton ? "Title" : "Title without-back-button"
                  }
                >
                  {showBackButton && (
                    <a
                      onClick={() => {
                        backTo
                          ? dispatch(push(`/${backTo}`))
                          : dispatch(goBack())
                      }}
                    >
                      <AIcon type="left" />
                      <div className="back-title">{backTo || "Back"}</div>
                    </a>
                  )}
                  {children}
                  {shareable && <ShareIcon />}
                  {moreActions && <MoreIcon />}
                </StickyCard>
              )
            }}
          </Sticky>
        </div>
      )

    return (
      <Card className={showBackButton ? "Title" : "Title without-back-button"}>
        {showBackButton && (
          <a
            onClick={() => {
              backTo ? dispatch(push(`/${backTo}`)) : dispatch(goBack())
            }}
          >
            <AIcon type="left" />
            <div className="back-title">{backTo || "Back"}</div>
          </a>
        )}

        {children}

        {shareable && <ShareIcon />}
        {moreActions && <MoreIcon />}
      </Card>
    )
  }
)

export const Title = TitleCard

export const CardHeader = props => (
  <Row className="CardHeader" type="flex" justify="start" align="middle">
    <Col xs={12} md={12}>
      <h2>{props.title}</h2>
    </Col>
    {props.buttonTitle && (
      <Col xs={12} md={12}>
        <Button
          className={props.buttonClassName}
          type="default"
          icon={props.buttonIcon}
          onClick={props.buttonOnClick}
          disabled={props.buttonDisabled}
          loading={props.buttonLoading}
          htmlType={props.buttonHtmlType}
        >
          {props.buttonTitle}
        </Button>
      </Col>
    )}
    {props.customActionComponent && (
      <Col className="ActionComponent" xs={12} md={12}>
        {props.customActionComponent}
      </Col>
    )}
  </Row>
)

export default Card



// WEBPACK FOOTER //
// ./src/core/Card.js